import React, { Component } from 'react';
import { Image, message } from 'antd';
import { FrownOutlined, CloseOutlined } from '@ant-design/icons';
import { callNative } from '../../utils/LZTools';
import '../assets/scss/Sudoku.scss';

// Item组件--所有格子的操作都可以在此进行，如果这些操作都能与"activedId"关联就更好了
class RowItem extends Component {
  render() {
    const { activedId, flag, content } = this.props;

    let prizeIsEmpty = content.image == undefined || content.image === '';
    let prizeImg = prizeIsEmpty ? require('../assets/img/prize_none.png') : (content.image || 'https://www.laizekeji.cn/laizehomeImg/placeholder.png');
    let prizeTitle = prizeIsEmpty ? "谢谢参与" : (content.title || '奖品');

    let con =  (
      <>
        <Image
            className='item_img'
            preview={false}
            src={prizeImg}
        />
        <div className='item_title'>{prizeTitle}</div>
      </>
    );

    return (
      <>
        <div className='row__item' id={`row_item_${flag}`}>
          <div className={activedId === flag ? 'row__item-active' : ''}></div>
          { con }
        </div>
      </>
    )
  }
}

export default class Sudoku extends Component {
  constructor(props) {
    super(props);

    const { prizeList, drawTimes } = props;

    let list = [{}];
    for (let i = 0; i < 8; i++) {
      if (i < prizeList.length) {
        let prize = prizeList[i];
        list.push(prize);
      } else {
        list.push({
          title: '谢谢惠顾',
          image: '',
        });
      }
    }

    this.state = {
      // 九宫格内容list
      list: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      // 被选中的格子的ID
      activedId: '',
      // 中奖ID
      prizeId: null,
      // 是否正在抽奖
      isRolling: false,
      // 剩余抽奖次数
      drawTimes: drawTimes || 0,
      // 奖品列表
      prizeList: list
    }

    this.stopRolling = this.stopRolling.bind(this);
  }

  handleBegin() {
    //本地记录的抽奖次数小于0，则不能开始抽奖
    if (this.state.drawTimes <= 0) {
      message.info("抽奖次数不足", 1);
      return;
    }

    // this.state.isRolling为false的时候才能开始抽，不然会重复抽取，造成无法预知的后果
    if (!this.state.isRolling) {
      callNative({
        "type":"request",
        "data":{
          "reqUrl":"/api/v1/newHome/participateInDraw",
          "callBackFunc":"showDialog",
          "params":{},
        }
      });

      // 点击抽奖之后，我个人做法是将于九宫格有关的状态都还原默认
      this.setState({
        activedId: '',
        prizeId: null,
        isRolling: true
      }, () => {
        // 状态还原之后才能开始真正的抽奖
        this.handlePlay()
      })
    }
  }

  handlePlay() {
    // 随机获取一个中奖ID
    let prize = Math.floor(Math.random() * 8);

    this.setState({
      prizeId: prize,
      activedId: 0
    })
    // 随机算出一个动画执行的最小次数，这里可以随机变更数值，按自己的需求来
    let times = this.state.list.length * Math.floor(2)
    this.setState({
      times: times
    })
    // 抽奖正式开始↓↓
    this.begin = setInterval(() => {
      // 以下是动画执行时对id的判断
      let num;
      if (this.state.activedId === '') {
        num = 0;
      } else {
        num = this.state.activedId;
        num = num === 9 ? 0 : (num + 1);
      }

      this.setState({
        activedId: num,
        actTimes: this.state.actTimes + 1,
      });

    }, 100);
  }

  stopRolling() {
    if (this.begin != undefined) {
      let { drawTimes } = this.state;
      let tempDrawTimes = drawTimes - 1 > 0 ? drawTimes - 1 : 0;

      clearInterval(this.begin);
      this.setState({
        activedId: '',
        isRolling: false,
        drawTimes: tempDrawTimes
      });
    }
  }

  updateDrawTimes(drawTimes) {
    this.setState({
      drawTimes: drawTimes
    });
  }

  render() {
    const { activedId, drawTimes, prizeList } = this.state;

    return (
      <div className="prize__container">
        <div className="content__area">
          <div className="area__row">
            <RowItem flag={1} content={prizeList[1]} activedId={activedId} />
            <RowItem flag={2} content={prizeList[2]} activedId={activedId} />
            <RowItem flag={3} content={prizeList[3]} activedId={activedId} />
          </div>
          <div className="area__row">
            <RowItem flag={8} content={prizeList[4]} activedId={activedId} />
            <div className="begin__btn" onClick={() => this.handleBegin()} >
              <div className="begin_btn_drawTimes" >剩余{drawTimes || 0}次</div>
            </div>
            <RowItem flag={4} content={prizeList[5]} activedId={activedId} />
          </div>
          <div className="area__row">
            <RowItem flag={7} content={prizeList[6]} activedId={activedId} />
            <RowItem flag={6} content={prizeList[7]} activedId={activedId} />
            <RowItem flag={5} content={prizeList[8]} activedId={activedId} />
          </div>
        </div>
      </div>
    );
  }

}
